import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import { forgotPassword } from "@features/auth/api/authApi";
import { ForgotPasswordRequest } from "../types/forgotPassword";

export const forgotPasswordAsync = async (request: ForgotPasswordRequest): Promise<ApiResponse<ApiMessageResponse>> => {
  return forgotPassword(request);
};
